<template>
  <!-- 展览详情 -->
  <div class="page-exbition-detail">
    <!-- <div class="g-line" v-if="pageType==='1'||pageType==='2'||pageType==='4'"></div> -->
    <!-- 辽博讲堂 -->
    <div class="m-banner-top" v-if="pageType === '5'">
      <div class="top-box">
        <div class="label-box">
          <h1 class="tc mb-20">{{detailData.title}}</h1>
          <p class="txt">
            <label>讲座时间：</label>
            <span>{{detailData.time}}</span>
          </p>
          <p class="txt">
            <label>讲座形式：</label>
            <span>{{detailData.address}}</span>
          </p>
          <p class="txt">
            <label>主讲嘉宾：</label>
            <span>{{detailData.speaker}}</span>
          </p>
        </div>

        <div class="pic-box" v-if="detailData.url">
          <videoPlayer class="video-box" :video-url="detailData.url" :videoId="detailData.id" :state="!stopVideo"></videoPlayer>
        </div>

        <div class="pic-box" v-if="!detailData.url && detailData.pic">
          <img v-lazy="detailData.pic">
        </div>
      </div>
    </div>

    <div class="m-banner-top" v-else-if="pageType === '3'">
      <div class="top-box">
        <div class="label-box">
          <h1 class="tc mb-20">{{detailData.title}}</h1>
          <p class="txt"><label>作者: </label>{{detailData.author}}</p>
          <p class="txt"><label>出版时间: </label>{{detailData.publishTime}}</p>
          <p class="txt"><label>出版社: </label>{{detailData.publisher}}</p>
        </div>

        <div class="pic-box" v-if="detailData.img">
          <img v-lazy="detailData.img">
        </div>
      </div>
    </div>

    <div class="intro g-pad-top" v-else>
      <h1 class="tc m-font-1">{{detailData.title}}</h1>
      <p class="time tc m-font-2" v-if="pageType==='1'">{{detailData.author}}</p>

      <p class="time tc m-font-2" v-if="pageType==='2'">会议时间：{{detailData.publishTime}}</p>

      <!-- 论文 -->
      <div class="time tc m-font-2" v-if="pageType==='4'">
        <p>{{detailData.author}}</p>
        <p class="mt-10">{{detailData.publishTime}}</p>
      </div>
      
      <!-- <div class="pic-box" v-if="detailData.img">
        <img v-lazy="detailData.img">
      </div> -->
    </div>

    <div class="com-wrap" style="padding-bottom:60px;">
      <h2 class="m-font-5" style="margin-top:0;" v-if="titleObj[pageType]">{{titleObj[pageType]}}</h2>
      <div class="g-detail-html trans" v-html="detailData.topic" v-if="pageType === '5'"></div>
      <div class="g-detail-html trans" v-html="detailData.summary" v-else></div>

      <div v-if="pageType === '2'">
        <h2 class="m-font-5">会议内容</h2>
        <div class="g-detail-html trans" v-html="detailData.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import videoPlayer from '@cmp/video-player'
export default {
  components: { videoPlayer },
  data() {
    return {
      pageType: this.$route.query.pageType,  // 5辽博讲堂 6资讯
      titleObj: {
        '1': '',
        '2': '会议摘要',
        '3': '图录简介',
        '4': '',
        '5': '讲座内容',
      },
      activeVal: '2',
      tabList: [
        {
          name: '展厅实景',
          val: '1'
        },
        {
          name: '展品详情',
          val: '2'
        }
      ],
      detailData: {
        content: ''
      },
      detailId: this.$route.query.id,
      stopVideo: false
    }
  },
  methods: {
    getDetailData() {
      this.$http
        .get('../singleMuseum/applet/science/detail', {
          id: this.detailId
        })
        .then(res => {
          if (res.success) {
            this.detailData = res.result
          } else {
            this.$message.error(res.message)
          }
        })
    },
    getDetailDataClass() {
      this.$http
        .get('../singleMuseum/applet/classRoom/detail', {
          id: this.detailId
        })
        .then(res => {
          if (res.success) {
            this.detailData = res.result
          } else {
            this.$message.error(res.message)
          }
        })
    },
    setBread() {
      // 动态修改面包屑
      this.pageType = this.$route.query.pageType || '1' // 1 科研课题  2 学术会议  3 精品图录 4 学术论文 5 辽博讲堂
      console.log('00', this.pageType)
      switch(this.pageType) {
        case '1':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '科研课题',
              href: '/research'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
        case '2':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '学术会议',
              href: '/research?pageType=2'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
        case '3':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '精品图录',
              href: '/research?pageType=3'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
        case '4':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '学术论文',
              href: '/research?pageType=4'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
        case '5':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '辽博讲堂',
              href: '/research?pageType=5'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
      }

      if(this.pageType === '3' || this.pageType === '5') {
        // 面包屑灰色底
        this.$store.dispatch('changeBreadStyleType', '2')
      } else {
        this.$store.dispatch('changeBreadStyleType', '1')
      }
    }
  },
  created() {
    this.setBread()

    if(this.pageType === '5') {
      this.getDetailDataClass()
    } else {
      this.getDetailData()
    }
  },
  beforeDestroy() {
    this.$store.dispatch('changeBreadStyleType', '')
  }
}
</script>

<style lang="scss" scoped>
.page-exbition-detail {
  min-height: calc(100vh - 110px);
  h1 {
    // font-size: 28px;
    // font-weight: bold;
    color: #000;
  }
  h2 {
    margin: 40px 0 40px;
    // font-size: 24px;
    color: #000;
  }
  .time {
    // font-size: 16px;
    color: #999493;
    margin-top: 20px;
    margin-bottom: 40px;
  }
  .intro {
    padding-left: 36px;
    padding-right: 36px;
  }
  // .pic-box {
  //   text-align: center;
  //   margin-bottom: 20px;
  //   img {
  //     max-width: 100%;
  //     max-height: 100%;
  //   }
  // }

  // .banner-top {
  //   padding: 40px 0 70px;
  //   background: #F6F6F6;
  //   .top-box {
  //     width: 1600px;
  //     margin: 0 auto;
  //     display: flex;
  //     align-items: center;
  //     justify-content: space-between;
  //     .label-box {
  //       flex: 1;
  //       font-size: 24px;
  //       color: #000000;
  //       h1 {
  //         text-align: left;
  //         margin-bottom: 60px;
  //       }
  //       .txt {
  //         margin-bottom: 20px;
  //         label {
  //           display: inline-block;
  //           // width: 110px;
  //           text-align: justify;
  //           margin-right: 20px;
  //           opacity: 0.7;
  //         }
  //       }
  //     }
  //     .pic-box {
  //       margin-left: 96px;
  //       margin-bottom: 0;
  //       width: 916px;
  //       height: 516px;
  //       display: flex;
  //       align-items: center;
  //       justify-content: center;
  //       .video-box {
  //         width: 916px;
  //         min-height: auto;
  //         margin: 0 auto;
  //       }
  //     }
  //   }
  // }

  .com-wrap {
    padding: 36px;
    // width: $minWidth;
    margin: 0 auto;
  }
}
</style>

